import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { accountingAccountSelected } from '../../../../scripts/list.selected.item.script';

export interface AppInventoryViewAccountingAccountsProps {
  display?: string,
  record: any | Service | Product
};

const AppInventoryViewAccountingAccounts: React.FunctionComponent<AppInventoryViewAccountingAccountsProps> = ({display, record}) => {
  const {companyForUser, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingProductAccountsForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  return (
    <>
      { companyForUser && accountingExpenseAccountsForCompany && accountingVatAccountsForCompany && accountingProductAccountsForCompany &&
        <div className={`card card-flush ${display || ""}`}>
          <div className="card-header">
            <div className="card-title">
              <h5>{lang.labels.accountingAccounts}</h5>
            </div>
          </div>
          <div className="card-body pt-0">
            <div className="pb-2">
              <div className="fs-8 text-muted d-flex align-items-center">
                {lang.labels.expenseAccount}:
                <i className="ms-2 fs-9" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.purchases}><FaExclamationCircle /></i>
              </div>
              <div className="fw-bold text-gray-900">{accountingAccountSelected(lang, accountingExpenseAccountsForCompany, record.accounts.expense, companyForUser.language)}</div>
            </div>
            <div className="pb-2">
              <div className="fs-8 text-muted d-flex align-items-center">
                {lang.labels.vatAccount}:
                <i className="ms-2 fs-9" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.purchases}><FaExclamationCircle /></i>
              </div>
              <div className="fw-bold text-gray-900">{accountingAccountSelected(lang, accountingVatAccountsForCompany, record.accounts.vat, companyForUser.language)}</div>
            </div>
            <div className="pb-0">
              <div className="fs-8 text-muted d-flex align-items-center">
                {lang.labels.accountProduct}:
                <i className="ms-2 fs-9" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.sales}><FaExclamationCircle /></i>
              </div>
              <div className="fw-bold text-gray-900">{accountingAccountSelected(lang, accountingProductAccountsForCompany, record.accounts.product, companyForUser.language)}</div>
            </div>
          </div>
        </div>
      }
    </>
  )
};

export default AppInventoryViewAccountingAccounts;
